<template>
  <div class="container">
    <div class="login-modal" id="loginModal" tabindex="-1" role="dialog" aria-labelledby="login" aria-hidden="true" >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <img src="/assets/img/svg/key.svg" alt="Login" />
          </div>
          <div class="modal-body">
            <div class="container-fluid">
              <div class="login-form">
                <vue-form :form="loginForm"></vue-form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueForm from "@/components/Form.vue";

export default {
  name: "login",

  components: { VueForm },

  data() {
    return {
      loginForm: {
        fields: {
          email: {
            type: "input",
            attributes: {
              type: "email",
              columns: 'col-auto',
              maxLength: 128,
              required: true,
              label: 'Email',
              labelClasses: 'sr-only',
              placeholder: 'Email',
              classes: 'form-control',
              inputGroupClasses: 'mb-2',
              img: '/assets/img/svg/user.svg',
              regex: this.$options.filters.translate("regex")['email']
            }
          },
          password: {
            type: "input",
            attributes: {
              type: "password",
              columns: 'col-auto',
              maxLength: 16,
              required: true,
              label: 'Password',
              labelClasses: 'sr-only',
              placeholder: 'Password',
              classes: 'form-control',
              inputGroupClasses: 'mb-2',
              img: '/assets/img/svg/lock.svg'
            }
          },
          loginBtn: {
            type: "button",
            attributes: {
              action: 'ajax',
              callType: 'store',
              endpoint: 'login',
              columns: 'col-auto mt-4',
              classes: 'button primary btn-block login-btn',
              value: 'Login',
              url: {module: "EmonAccessManagement", name: "Login"},
              callback: {
                redirect: {url: 'home', fields: []}
              },
            }
          }
        },
        settings: {
          classes: "login-form",
        }
      }     
    };
  }
};
</script>

